import { render, staticRenderFns } from "./relationPres.vue?vue&type=template&id=9ab6baf4&scoped=true"
import script from "./relationPres.vue?vue&type=script&lang=ts"
export * from "./relationPres.vue?vue&type=script&lang=ts"
import style0 from "./relationPres.vue?vue&type=style&index=0&id=9ab6baf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab6baf4",
  null
  
)

export default component.exports